import { api } from '@/services'

export function create(request) {
    return api.post('/admin/realEstate/create', request)
}
export function update(request) {
    return api.put(`/admin/realEstate/update/${request.id}`, request)
}
export function show(realEstateId) {
  return api.get(`/admin/realEstate/show/${realEstateId}`)
}

export function listActiveServiceTypes(realEstateId) {
  const roles = localStorage.getItem('access_roles')
  const userRoles = roles?.split(',')

  if (userRoles?.includes('ROLE_ADMIN')) {
    return api.get(`/admin/realEstate/activeServiceTypes/${realEstateId}`)
  }

  return api.get('/web/realEstate/activeServiceTypes')
}
